import { render } from "./MainMenu.vue?vue&type=template&id=11a9a8a7&ts=true"
import script from "./MainMenu.ts?vue&type=script&lang=ts&external"
export * from "./MainMenu.ts?vue&type=script&lang=ts&external"

import "./MainMenuIcons.scss?vue&type=style&index=0&lang=scss&external"
import "./MainMenu.vue?vue&type=style&index=1&id=11a9a8a7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__